import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAcademicYearForm from "../../forms/CreateOrUpdateAcademicYearForm";
import { AcademicYearResponseDto } from "../../shared/dtos/academicYear/AcademicYearResponseDto";

interface UpdateAcademicYearModalProps {
  open: boolean;
  onClose: () => void;
  academicYear: AcademicYearResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateAcademicYearModal: React.FC<UpdateAcademicYearModalProps> = ({
  open,
  onClose,
  academicYear,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit: ${academicYear.name}`}
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateAcademicYearForm
        isEditing={true}
        academicYear={academicYear}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default UpdateAcademicYearModal;
